module.exports = __webpack_public_path__ + "media/images/menu-publishers-icon-58452a921bcd53c8f0b7c64e7b25c6bd.svg";